import { render, staticRenderFns } from "./WebsitePageInput.vue?vue&type=template&id=0b3647a2&scoped=true"
import script from "./WebsitePageInput.vue?vue&type=script&lang=js"
export * from "./WebsitePageInput.vue?vue&type=script&lang=js"
import style0 from "./WebsitePageInput.vue?vue&type=style&index=0&id=0b3647a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3647a2",
  null
  
)

export default component.exports